module.exports = __webpack_public_path__ + "static/img-old-stemi-c947eb365f22e9b847ff04e81896cfe0.png";